import React from 'react';
interface BadgeProps {
  icon?: React.ReactNode;
  text: string;
}
export function Badge({
  icon,
  text
}: BadgeProps) {
  return <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-wider mb-6" data-id="element-30">
      {icon && <span className="text-blue-600" data-id="element-31">{icon}</span>}
      {text}
    </div>;
}